import React from 'react';
import "../template-file-css/document-file-template.css";
import { TableChart } from '@mui/icons-material';


export const GENERAL_AIMS = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_AIMS' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'>
                    <b>Code:</b> 0 = None; 1 = Minimal; 2 = Mild; 3 = Moderate; 4 = Severe
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Movement Ratings: </span>
                    <ul>
                        <li>Rate highest severity observed in category I, II, III.</li>
                        <li>Rate movements that occur upon activation one point less than those observed spontaneously.</li>
                        <li>Circle movements as well as code number that applies.</li>
                    </ul>
                </p>
                <table>

                    <tr>
                        <td className='w-187'><span className='eleHeader  text-center'> Rater </span> </td>
                        <td className='w-187'><span className='eleHeader  text-center'> Rater </span> </td>
                        <td className='w-187'><span className='eleHeader  text-center'> Rater </span> </td>
                        <td className='w-187'><span className='eleHeader  text-center'> Rater </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187 text-center'><input type='text' id="txtRater_1" name="txtRater_1" className="add-only text-center" /></td>
                        <td className='w-187 text-center'><input type='text' id="txtRater_2" name="txtRater_2" className="add-only text-center" /></td>
                        <td className='w-187 text-center'><input type='text' id="txtRater_3" name="txtRater_3" className="add-only text-center" /></td>
                        <td className='w-187 text-center'><input type='text' id="txtRater_4" name="txtRater_4" className="add-only text-center" /></td>
                    </tr>

                    <tr>
                        <td className='w-187'><span className='eleHeader  text-center'> Date </span> </td>
                        <td className='w-187'><span className='eleHeader  text-center'> Date </span> </td>
                        <td className='w-187'><span className='eleHeader  text-center'> Date </span> </td>
                        <td className='w-187'><span className='eleHeader  text-center'> Date </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187  text-center'><input type='date' id="txtDate_1" name="txtDate_1" className="add-only" /></td>
                        <td className='w-187 text-center'><input type='date' id="txtDate_2" name="txtDate_2" className="add-only" /></td>
                        <td className='w-187 text-center'><input type='date' id="txtDate_3" name="txtDate_3" className="add-only " /></td>
                        <td className='w-187 text-center'><input type='date' id="txtDate_4" name="txtDate_4" className="add-only" /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> I: FACIAL & ORAL MOVEMENTS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>1. Muscles of Facial Expression</b><br />
                            e.g. movements of forehead, eyebrows,
                            periorbital area, cheeks, including frowning, blinking, smiling, grimacing
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_1_1" name="ddl_I_1_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_1_2" name="ddl_I_1_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_1_3" name="ddl_I_1_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_1_4" name="ddl_I_1_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>2. Lips and Perioral Area</b><br />e.g. puckering, pouting, smacking
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_2_1" name="ddl_I_2_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_2_2" name="ddl_I_2_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_2_3" name="ddl_I_2_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_2_4" name="ddl_I_2_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>3. Jaw</b><br />Biting, clenching, chewing, mouth
                            opening , lateral movement
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_3_1" name="ddl_I_3_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_3_2" name="ddl_I_3_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_3_3" name="ddl_I_3_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_3_4" name="ddl_I_3_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr >
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>4. Tongue</b><br />
                            Rate only increases in movement
                            both in and out of mouth. NOT inability to
                            sustain movement. Darting in and out of
                            mouth.
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_4_1" name="ddl_I_4_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_4_2" name="ddl_I_4_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_4_3" name="ddl_I_4_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_4_4" name="ddl_I_4_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> II: EXTREMITY MOVEMENTS </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <b>5. Upper (arms, wrists, hands, fingers)</b><br />
                            Include choreic movements (i.e. rapid
                            objectively purposeless, irregular,
                            spontaneous) athetoid movements. DO NOT
                            INCLUDE TREMOR (i.e. repetitive, regular,
                            rhythmic)
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_5_1" name="ddl_I_5_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_5_2" name="ddl_I_5_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_5_3" name="ddl_I_5_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_5_4" name="ddl_I_5_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr >
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>6. Lower (legs, knees, ankles, toes)</b><br />
                            Lateral knee movement, foot tapping, heel
                            dropping, foot squirming, inversion and
                            eversion of foot
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_6_1" name="ddl_I_6_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_6_2" name="ddl_I_6_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_6_3" name="ddl_I_6_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_6_4" name="ddl_I_6_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> III: TRUNK MOVEMENTS </span> </td>
                    </tr>
                    <tr>
                        <td className="w-350">
                            <b>7. Neck, shoulders and hips</b><br />
                            Rocking, twisting, squirming, pelvic gyrations
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_7_1" name="ddl_I_7_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_7_2" name="ddl_I_7_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_7_3" name="ddl_I_7_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_7_4" name="ddl_I_7_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> IV: GLOBAL JUDGEMENT </span> </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>8. Severity of abnormal movements overall</b>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_8_1" name="ddl_I_8_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_8_2" name="ddl_I_8_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_8_3" name="ddl_I_8_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_8_4" name="ddl_I_8_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>9. Incapacitation due to abnormal movements</b>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_9_1" name="ddl_I_9_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_9_2" name="ddl_I_9_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_9_3" name="ddl_I_9_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_9_4" name="ddl_I_9_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>10. Patient's awareness of abnormal movements. Rate only patients report:</b><br />
                            No Awareness = 0; Aware, no distress = 1; Aware, mild distress = 2;
                            Aware, moderate distress = 3; Aware, severe distress = 4
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_10_1" name="ddl_I_10_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_10_2" name="ddl_I_10_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_10_3" name="ddl_I_10_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_10_4" name="ddl_I_10_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> V: DENTAL STATUS  </span> </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>11. Current problems with teeth and/or dentures</b>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_11_1" name="ddl_I_11_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_11_2" name="ddl_I_11_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_11_3" name="ddl_I_11_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_11_4" name="ddl_I_11_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>12. Are dentures usually worn</b>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_12_1" name="ddl_I_12_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_12_2" name="ddl_I_12_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_12_3" name="ddl_I_12_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_12_4" name="ddl_I_12_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>13. Endentia?</b>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_13_1" name="ddl_I_13_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_13_2" name="ddl_I_13_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_13_3" name="ddl_I_13_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_13_4" name="ddl_I_13_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-350 background-color:#f2f2f2;">
                            <b>14. Do movements disappear with sleep?</b>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_14_1" name="ddl_I_14_1" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_14_2" name="ddl_I_14_2" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_14_3" name="ddl_I_14_3" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                        <td className="w-100 vertical-align:top;padding-top:4px;">
                            <select id="ddl_I_14_4" name="ddl_I_14_4" className="add-only">
                                <option value="0">0 = None</option>
                                <option value="1">1 = Minimal</option>
                                <option value="2">2 = Mild</option>
                                <option value="3">3 = Moderate</option>
                                <option value="4">4 = Severe</option>
                            </select>
                        </td>
                    </tr>
                </table>
            </div>
        </form>
    )
}